import { Suspense } from 'react';
import Conversations from '@/pages/Conversations';
import { LazyConversationsV2, PageLoader } from '@/lazy-routes';
import { ConversationsV2Boundary } from '@/components/platform-admin/ConversationsV2CrashBoundary';
import { useConversationsVersion } from '@/modules/conversations/hooks/useConversationsVersion';

/**
 * What `/conversations` renders.
 *
 * Both screens live behind the same URL so the operator can move between them without leaving the
 * page they work in. The preference is per browser (localStorage), so switching never changes what
 * anyone else sees, and `?v=1` / `?v=2` pins a version for a shared link.
 *
 * V1 is imported eagerly — going back is a re-render, never a download.
 */
export default function ConversationsSwitch() {
  const { version } = useConversationsVersion();

  if (version === 'v2') {
    return (
      <ConversationsV2Boundary classicPath="/conversations">
        <Suspense fallback={<PageLoader />}>
          <LazyConversationsV2 />
        </Suspense>
      </ConversationsV2Boundary>
    );
  }

  return <Conversations />;
}
